import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, Pricing, WhyUs, ProjectSection, Events, Process, NewsletterSection, Features, Clients, Awards } from '../../sections';

// Importing additional components used in the homepage
import { Banner, Calculator } from '../../components';

const HomePage = () => {

  return (
    <div className='homepage'>

      <Home /> {/* Hero section with an introduction to the website */}
      <Features /> {/* Section highlighting key features */}
      <About /> {/* About Us section providing company background */}
      <Counter /> {/* Counter section showing important statistics */}
      <Services /> {/* Services section listing available offerings */}
      <WhyUs /> {/* Section explaining why to choose this business */}
      <Process /> {/* Process section outlining the workflow or steps */}
      <Banner /> {/* Promotional banner or call-to-action section */}
      <ProjectSection /> {/* Showcase of completed projects */}
      <Testimonials /> {/* Client reviews and testimonials */}
      <Team /> {/* Meet the team section introducing team members */}
      <Calculator /> {/* Appointment booking or cost estimation section */}
      <Pricing /> {/* Pricing plans for various services */}
      <Awards linear /> {/* Achievements and awards section */}
      <Events /> {/* Upcoming events or activities */}
      <NewsletterSection /> {/* Newsletter subscription section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Sponsors or client logos section */}

    </div>
  )
}

export default HomePage;